// Libraries
import React from 'react';

// Supermove
import {gql} from '@supermove/graphql';
import {useQuery} from '@supermove/hooks';
import {JobModel} from '@supermove/models';

// Shared
import Hint from '@shared/design/components/Hint';
import UserRole from '@shared/modules/User/enums/UserRole';

const JobActionDisabledTooltip = ({
  job,
  customMessage,
  children,
}: {
  job: JobModel;
  customMessage?: string;
  children: React.ReactNode;
}) => {
  const {data} = useQuery(JobActionDisabledTooltip.query, {
    fetchPolicy: 'cache-first',
  });
  const tooltip = UserRole.getJobActionDisabledTooltip(data?.viewer.role);
  const message = customMessage || (job.isFinal ? tooltip : '');

  return <Hint message={message}>{children}</Hint>;
};

// --------------------------------------------------
// Data
// --------------------------------------------------
JobActionDisabledTooltip.query = gql`
  query JobActionDisabledTooltip {
    viewer {
      id
      role
    }
  }
`;

JobActionDisabledTooltip.fragment = gql`
  fragment JobActionDisabledTooltip on Job {
    id
    isFinal
  }
`;

export default JobActionDisabledTooltip;
